import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { TStrapiV4GuidesWidget } from '../../common-types'
import GuidesCard from '@/stories/strapi-4/widget-components/guides-widget/GuidesCard'

type TProps = TStrapiV4GuidesWidget & { notHero?: boolean }

const StrapiV4GuidesWidget = (props: TProps) => {
  const { showSteps, guide_data, selectedStep, notHero } = props
  const [selectedIdx, setselectedIdx] = useState<number>(selectedStep ?? 0)

  useEffect(() => {
    setselectedIdx(selectedStep ?? 0)
  }, [selectedStep])

  if (!guide_data?.length) return null

  const currentStep = selectedIdx + 1
  return (
    <div
      className={classNames('py-8 xl:py-12', {
        'herolike-wrapper': !notHero,
      })}
    >
      {showSteps && (
        <div className="relative mx-auto w-full max-w-2xl pb-8">
          <div className="relative flex items-center justify-between">
            <div className="bg-brand-grey-light absolute left-0 right-0 top-4 h-0.5" />
            <div
              className="bg-brand-green-dark absolute left-0 top-4 h-0.5 transition-all duration-300"
              style={{
                width: `${
                  ((currentStep - 1) / (guide_data.length - 1)) * 100
                }%`,
              }}
            />

            {guide_data.map(({ stepText }, idx) => (
              <div key={idx} className="relative flex flex-col items-center">
                <div
                  onClick={() => setselectedIdx(idx)}
                  className={classNames(
                    `flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border-2 bg-white `,
                    {
                      'border-brand-green-dark text-brand-green-dark':
                        idx + 1 <= currentStep,
                      'border-brand-grey-light text-brand-grey-light hover:text-brand-green-dark hover:border-brand-green-dark':
                        idx + 1 > currentStep,
                    },
                  )}
                >
                  {idx + 1}
                </div>
                <span
                  className={classNames(`mt-2 text-sm font-medium`, {
                    'text-brand-green-dark': idx + 1 <= currentStep,
                    'text-brand-grey-light': idx + 1 > currentStep,
                  })}
                >
                  {stepText}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="flex w-full flex-col items-center justify-start gap-10 md:gap-14">
        {guide_data.map((data, idx) => {
          return selectedIdx === idx || !showSteps ? (
            <GuidesCard
              key={idx}
              widgetData={data}
              className={classNames({
                block: selectedIdx === idx || !showSteps,
                hidden: selectedIdx !== idx && showSteps,
              })}
            />
          ) : null
        })}
      </div>
    </div>
  )
}

export default StrapiV4GuidesWidget
